module.exports = __webpack_public_path__ + "static/media/Schueler_Task.7ceb28fa.svg";